console.log(process.env,'process.envprocess.env')
const downAPI = process.env.DOWN_URL;
const downAPIH5 = process.env.DOWN_URL_H5;


function _import (filePath=''){
    return ()=>import('@/views/'+filePath);
}
function isIos(){
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isiOS;
}
const cdnUrl = 'https://oss.tuidis.com/activity_pages/img/';

const formatPostTime = (dateString)=> {
    // 将输入的日期字符串转换为Date对象
    const postDate = new Date(dateString);
    const now = new Date();
    if(!postDate) return ''
    // 计算时间差（毫秒）
    const diffMs = now - postDate;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    
    // 计算日期差
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const postStartOfDay = new Date(postDate.getFullYear(), postDate.getMonth(), postDate.getDate());
    const dayDiff = Math.floor((startOfDay - postStartOfDay) / (1000 * 60 * 60 * 24));
    
    // 获取时间部分（小时和分钟）
    const hours = String(postDate.getHours()).padStart(2, '0');
    const minutes = String(postDate.getMinutes()).padStart(2, '0');
    
    // 根据不同情况返回不同格式
    if (dayDiff === 0) {
      // 当天
      if (diffMin < 1) {
        return '刚刚';
      } else if (diffMin < 60) {
        return `${diffMin}分钟前`;
      } else {
        return `${hours}:${minutes}`;
      }
    } else if (dayDiff === 1) {
      // 昨天
      return `昨天${hours}:${minutes}`;
    } else {
      // 非昨天的过去日期
      const month = String(postDate.getMonth() + 1).padStart(2, '0');
      const day = String(postDate.getDate()).padStart(2, '0');
      return `${month}-${day} ${hours}:${minutes}`;
    }
  }

const formatDate = (date, format = "yyyy-MM-dd HH:mm:ss")=>{
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const toSymbol = () => {
      return hours > 12 ? "下午" : "上午";
    };
    const hasSymbol = format.indexOf('a') > -1
    const symbols = {
      yyyy: year,
      MM: `${month}`.padStart(2, "0"),
      dd: `${day}`.padStart(2, "0"),
      HH: `${hours}`.padStart(2, "0"),
      hh: hasSymbol && hours > 12 ? hours - 12 : hours,
      mm: `${minutes}`.padStart(2, "0"),
      ss: `${seconds}`.padStart(2, "0"),
      // a 表示12小时制
      a: toSymbol(),
    };
    let time = format;

    Object.keys(symbols).forEach((key) => {
      time = time.replace(key, symbols[key]);
    });
    return time;
}

const getDownUrl =(aid=28, appName='tuiqiu', channel='9998', apptype=0,memberId)=>{
        
        const clientType = isIos() ? '5' : '4';
        let appid = (appName == 'tuiqiu'||appName == 'web') ? '8' : '11'; // 8新长乐，9是1号店，10是老长乐，11是推店
        let downUrl = '';
        if (apptype == 0){ //0是APP 1是h5
            downUrl = `${downAPI}/app/down.do?appId=${appid}&aid=${channel}&clientType=${clientType}`;
        }else{
            if (isIos()) {
                channel > 6 && (channel = '0');
                downUrl = `${downAPIH5}?aid=${channel}`;
            } else {
                downUrl = `${downAPI}/app/down.do?appId=${appid}&aid=${channel}&clientType=${clientType}`;
            }
        }
        return {
          aid,
          appName,
          channel,
          appid,
          apptype,
          downUrl
        };
}
const getShopType=(appName)=>{
  if(appName=='tuiqiu'||appName ==='web'){
                return  0;
            }else if(appName == 'yhcaidian'){
                return 1
            }else if(appName=='changle'){
                return 4;
            }else if(appName=='tuidian'){
                return 5;
            }else{
                return 0;
            }
}

export {_import,isIos,cdnUrl,formatPostTime,formatDate,getDownUrl,getShopType};





// WEBPACK FOOTER //
// ./src/utils/index.js